import React from "react";
import calculatorsData from "../countriesCalculatorData";
function MainCalculatorsList() {
  let calculatorsList = calculatorsData.EG;
  let calculatorName = "حواسب مصر";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map(
            (item, index) =>
              item.showMain && (
                <li key={index}>
                  <a href={item.url} className="item-link">
                    {item.name}
                  </a>
                </li>
              )
          )}
        </ul>
        <div style={{ textAlign: "center" }}>
          <a
            className="btn btn-success"
            style={{ width: "90%" }}
            href={"/calculator/ar/countries/SA/calculators-list/"}
          >
            المزيد
          </a>
          <hr />
        </div>
         </div>
</div>
  );
}
export default MainCalculatorsList;
